export default __webpack_public_path__ + "static/media/detail.21f51896.svg";